import { REDUCE_STOREFRONT_CONFIGURATION } from '../../constants/actions/storefront';

export default function reduceStorefrontConfiguration(payload) {
    return {
        type: REDUCE_STOREFRONT_CONFIGURATION,
        payload,
    };
}
